import React, { useState } from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';


// Define styles
const formContainerStyle = {
  maxWidth: '800px',
 marginTop:'15px',
  padding: '20px',
  border: '1px solid #ced4da',
  borderRadius: '0.25rem',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
};

const formGroupStyle = {
  marginBottom: '20px',
};

const formLabelStyle = {
  fontSize: '1rem',
  fontWeight: '500',
  color: '#495057',
};

const requiredIndicatorStyle = {
  color: '#dc3545',
};

const selectStyle = {
  borderColor: '#ced4da',
  borderRadius: '0.25rem',
};





const ReportForm = () => {
  const [startDate, setStartDate] = useState('2024-08-01');
  const [endDate, setEndDate] = useState('2024-08-31');
  const [groupBy, setGroupBy] = useState('');
  const [topFilter, setTopFilter] = useState('number');
  const [top, setTop] = useState('');
  const [tags, setTags] = useState([]);
  const [procedureFilter, setProcedureFilter] = useState('include');
  const [includeInactive, setIncludeInactive] = useState(false);
  const [procedures, setProcedures] = useState([]);
  const [byAttributes, setByAttributes] = useState(false);
  const [excludeMaterials, setExcludeMaterials] = useState(false);
  const [excludeZeroAttributes, setExcludeZeroAttributes] = useState(false);
  const [excludeAdditionalLines, setExcludeAdditionalLines] = useState(false);
  const [excludeTaxes, setExcludeTaxes] = useState(false);
  const [financeCharges, setFinanceCharges] = useState(false);
  const [format, setFormat] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission here
  };

  return (
    <div style={formContainerStyle}>
      <Form onSubmit={handleSubmit}>
        <fieldset>
        <h2 className="text-left mb-4 text-dark">Parameters</h2>

          <Form.Group as={Row} controlId="top-customer-start-date" style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>
              Start Date <span style={requiredIndicatorStyle}>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
                style={selectStyle}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="top-customer-end-date" style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>
              End Date <span style={requiredIndicatorStyle}>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
                style={selectStyle}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="report_top_customer_group_by" style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>Group By</Form.Label>
            <Col sm={9}>
              <Form.Control
                as="select"
                value={groupBy}
                onChange={(e) => setGroupBy(e.target.value)}
                style={selectStyle}
              >
                <option value="">No Grouping</option>
                <option value="state">State</option>
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row} style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>Top Customers</Form.Label>
            <Col sm={9}>
              <Form.Check
                type="radio"
                label="Number"
                name="top_filter"
                value="number"
                checked={topFilter === 'number'}
                onChange={(e) => setTopFilter(e.target.value)}
              />
              <Form.Check
                type="radio"
                label="Percent"
                name="top_filter"
                value="percent"
                checked={topFilter === 'percent'}
                onChange={(e) => setTopFilter(e.target.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="top" style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>Top</Form.Label>
            <Col sm={9}>
              <Form.Control
                type="number"
                min="1"
                max="402"
                value={top}
                onChange={(e) => setTop(e.target.value)}
                style={selectStyle}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="report_top_customer_account_tags" style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>Account Tags</Form.Label>
            <Col sm={9}>
              <Form.Control
                as="select"
                multiple
                value={tags}
                onChange={(e) => setTags([...e.target.selectedOptions].map(option => option.value))}
                style={selectStyle}
              >
                <option value="">No filter</option>
                <option value="a-practices">a-practices</option>
                <option value="bhandal">bhandal</option>
                <option value="coventry-dental">coventry-dental</option>
                <option value="dental-beauty">dental-beauty</option>
                <option value="murray-dental-">murray-dental-</option>
                <option value="swissmeda">swissmeda</option>
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row} style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>Procedures</Form.Label>
            <Col sm={9}>
              <Form.Check
                type="radio"
                label="Include"
                name="procedure_filter"
                value="include"
                checked={procedureFilter === 'include'}
                onChange={(e) => setProcedureFilter(e.target.value)}
              />
              <Form.Check
                type="radio"
                label="Exclude"
                name="procedure_filter"
                value="exclude"
                checked={procedureFilter === 'exclude'}
                onChange={(e) => setProcedureFilter(e.target.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="include_inactive" style={formGroupStyle}>
            <Col sm={3}>
              <Form.Check
                type="checkbox"
                label="Inactive Selectable?"
                checked={includeInactive}
                onChange={(e) => setIncludeInactive(e.target.checked)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="report_top_customer_sales_procedure" style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>Procedures</Form.Label>
            <Col sm={9}>
              <Form.Control
                as="select"
                multiple
                size="10"
                value={procedures}
                onChange={(e) => setProcedures([...e.target.selectedOptions].map(option => option.value))}
                style={selectStyle}
              >
                <option value="">All</option>
                {/* Add options here as needed */}
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row} style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>Options</Form.Label>
            <Col sm={9}>
              <Form.Check
                type="checkbox"
                label="Base report on Attributes"
                checked={byAttributes}
                onChange={(e) => setByAttributes(e.target.checked)}
              />
              <Form.Check
                type="checkbox"
                label="Exclude Materials and Alloys"
                checked={excludeMaterials}
                onChange={(e) => setExcludeMaterials(e.target.checked)}
              />
              <Form.Check
                type="checkbox"
                label="Exclude Attributes when units and price are zero"
                checked={excludeZeroAttributes}
                onChange={(e) => setExcludeZeroAttributes(e.target.checked)}
              />
              <Form.Check
                type="checkbox"
                label="Exclude Additional Lines"
                checked={excludeAdditionalLines}
                onChange={(e) => setExcludeAdditionalLines(e.target.checked)}
              />
              <Form.Check
                type="checkbox"
                label="Exclude Taxes"
                checked={excludeTaxes}
                onChange={(e) => setExcludeTaxes(e.target.checked)}
              />
              <Form.Check
                type="checkbox"
                label="Include Finance Charges"
                checked={financeCharges}
                onChange={(e) => setFinanceCharges(e.target.checked)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="report_top_customer_format" style={formGroupStyle}>
            <Form.Label column sm={3} style={formLabelStyle}>
              Format <span style={requiredIndicatorStyle}>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                as="select"
                value={format}
                onChange={(e) => setFormat(e.target.value)}
                required
                style={selectStyle}
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

        <Form.Group as={Row}>
                 <Col sm={{ span: 8, offset: 4 }}>
                   <Link to="/Addcustomersale">
                     <Button
                       id="pay-per-task-submit"
                       type="button"
                       variant="primary"
                       className="w-100 mt-2"
                       style={{
                         backgroundColor: '#004aad',
                         borderColor: '#004aad',
                         marginTop: '10px',
                       }}
                     >
                       Run
                     </Button>
                   </Link>
                 </Col>
                </Form.Group>
        </fieldset>
      </Form>
     
    </div>
  );
};

export default ReportForm;
